export const environment = process.env.NODE_ENV
export const cacheDuration = environment === 'development' ? 0 : 60 * 1000 // was 2 * 60 * 60 * 1000

export const CVETA_SB_ACCOUNT_INFO = {
	userId: '477586',
	nickname: 'Cveta @ Dieta',
	profileUrl: 'https://dieta-public-resources.s3.us-west-2.amazonaws.com/users/Cveta.png',
}
export const SUPPORT_SB_ACCOUNT_INFO = 'google-oauth2|118369740915804905723'
